function padStart(source, maxLength, fillString) {
  return source.padStart(maxLength, fillString);
}

module.exports = padStart;



// WEBPACK FOOTER //
// ./src/utils/padstart.js